import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import classname from 'classname';
import { Field } from 'redux-form';

import inputField from '../../../shared/form-elements/input';
import checkboxField from '../../../shared/form-elements/checkbox';

import { Link } from 'react-router';
import { baseUrl } from '../../../../config/route-entry-point';

lessRequire('modules/streams/components/stream-form/part-postback.less');

const PartPostback = props => {
	const { active, list } = props.sections;
	const { onChecked, intl } = props;
	const className = classname({
		'stream-form__postback': true,
		'active': active === list.postback
	});
	const disabledStatus = props.formData.checkboxDisabledStatus;
	const {affiliate_id, offer_id} = props.data.streamItemData || {};
	const current_offer_id = props.selectedOffer && props.selectedOffer.id;
	const current_user_id = props.user && props.user.id;

	const {redeemNotificationAffiliates, redeemNotificationOffers} = window.globalConfig;
	const isShownPostbackRedeem = redeemNotificationAffiliates.includes(affiliate_id || current_user_id) &&
		redeemNotificationOffers.includes(offer_id || current_offer_id);

	return (
		<div className={className}>
			<div className="stream-form__postback-url">
				<Field name="postback_url"
					placeholder={intl('Постбэк URL')}
					component={inputField}
					errors={props.formData.errors}
					shouldDisable={props.isEditMode && !props.canEdit}/>
			</div>

			<div className="stream-form__postback-checkbox-wrap">
				<Field name="postback_send_status"
					labelText={intl('Постбэк при смене статуса')}
					shouldDisable={disabledStatus.postback_send_status || (props.isEditMode && !props.canEdit)}
					onChange={e => onChecked(e.currentTarget.id)}
					component={checkboxField} />

				<Field name="postback_ignore_trash"
					labelText={intl('Не слать постбэк по лидам со статусом trash')}
					shouldUncheck={disabledStatus.postback_ignore_trash}
					shouldDisable={disabledStatus.postback_ignore_trash || (props.isEditMode && !props.canEdit)}
					component={checkboxField} />

				<Field name="postback_only_approved"
					labelText={intl('Лиды в статусе "approved"')}
					shouldDisable={disabledStatus.postback_only_approved || (props.isEditMode && !props.canEdit)}
					onChange={e => onChecked(e.currentTarget.id)}
					component={checkboxField} />
				<Field name="postback_only_pending"
					labelText={intl('Лиды в статусе "pending"')}
					component={checkboxField}
					shouldDisable={disabledStatus.postback_only_pending || (props.isEditMode && !props.canEdit)}
				/>
				<Field name="send_payout_for_approved_only"
					labelText={intl('Слать выплату только по апрувнутым лидам')}
					component={checkboxField}
					shouldDisable={disabledStatus.send_payout_for_approved_only || (props.isEditMode && !props.canEdit)}
				/>
				<Field name="postback_ignore_restricted"
					labelText={intl('Не слать постбек по restricted регионам')}
					component={checkboxField}
				/>
				<Field name="postback_only_rejected"
					labelText={intl('Лиды в статусе "rejected"')}
					component={checkboxField}
					shouldDisable={disabledStatus.postback_only_rejected || (props.isEditMode && !props.canEdit)}
				/>
				<Field name="postback_on_payout_change"
					labelText={intl('Постбек при смене payout')}
					component={checkboxField}
				/>
				<Field name="postback_only_trash"
					labelText={intl('Лиды в статусе "trash"')}
					component={checkboxField}
					shouldDisable={disabledStatus.postback_only_trash || (props.isEditMode && !props.canEdit)}
				/>
			</div>

			<div className="stream-form__postback-info clearfix">
				<div className="stream-form__postback-info-block">
					<p>
						{intl('Постбэк URL будет полезен, если Вам необходимо в автоматическом режиме получать')}&nbsp;
						{intl('информацию о совершенной конверсии.')}
					</p>

					<p>
						{intl('Например, в случае, когда Вы ведете учет конверсий в сторонней системе статистики')}&nbsp;
						{intl('или отслеживаете конверсии на источниках трафика.')}
					</p>
				</div>

				<div className="stream-form__postback-info-block">
					<p>
						{intl('Постбэк запрос будет отправлен на указанный адрес методом')} <span>GET</span>.&nbsp;
						{intl('Для передачи параметров в запрос Вы можете использовать макросы, указанные ниже.')}&nbsp;
						{intl('Пример, постбэк ссылки для передачи суммы заработка и субаккаунта:')}&nbsp;
						<span>{' http://example.com/mystat.php?myprofit={payout}&mySubID={sid1}'}</span>.
						{intl('В момент перехода макросы')}&nbsp;
						<span>{'{payout}'}</span> {intl('и')}
						<span>{'{sid1}'}</span> {intl('будут заменены на соответствующие значения.')}
					</p>
				</div>
			</div>

			<table className="dashboard-table stream-form__postback-table">
				<thead className="dashboard-table__head font-proxima-nova-semibold">
					<tr>
						<th>{intl('Макрос')}</th>
						<th>{intl('Значение')}</th>
					</tr>
				</thead>
				<tbody className="dashboard-table__body">
					<tr>
						<td className="macros_title"><span>id</span></td>
						<td className="macros_value"><span>{intl('id конверсии')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>date</span></td>
						<td className="macros_value"><span>{intl('время конверсии UTC+0')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>campaign_id</span></td>
						<td className="macros_value"><span>{intl('идентификатор потока')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>campaign_language</span></td>
						<td className="macros_value"><span>{intl('язык кампании')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>offer_id</span></td>
						<td className="macros_value"><span>{intl('идентификатор оффера')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>country_code</span></td>
						<td className="macros_value"><span>{intl('код страны')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>ip</span></td>
						<td className="macros_value"><span>{intl('IP адрес')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>traffic_type</span></td>
						<td className="macros_value"><span>{intl('Тип траффика')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>sid1, sid2, sid3, sid4, sid5</span></td>
						<td className="macros_value"><span>sid1, sid2, sid3, sid4, sid5</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>status</span></td>
						<td className="macros_value">
							<span>
								{intl('статус конверсии')}
								{' '}
								{intl(
									'("pending" - ожидает обработки, "approved" - подтверждено,' +
									' "rejected" - отклонено, "trash" - невалидный)'
								)}
							</span>
						</td>
					</tr>
					<tr>
						<td className="macros_title"><span>payout</span></td>
						<td className="macros_value"><span>{intl('размер выплаты')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>currency</span></td>
						<td className="macros_value"><span>{intl('валюта выплаты')}</span></td>
					</tr>
					{
						isShownPostbackRedeem && (
							<tr>
								<td className="macros_title"><span>is_redeemed</span></td>
								<td className="macros_value"><span>{intl('выкуп') + ': true, false'}</span></td>
							</tr>
						)
					}
					<tr>
						<td className="macros_title"><span>type</span></td>
						<td className="macros_value"><span>{intl('тип конверсии')} ("cpa", "cancellations")</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>campaign_country_code</span></td>
						<td className="macros_value"><span>{intl('ГЕО потока')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>reason</span></td>
						<td className="macros_value"><span>{intl('Причина отмены')}</span></td>
					</tr>
				</tbody>
			</table>

			<Link to={baseUrl('campaigns/')} className="button  stream-back font-proxima-nova-semibold">{intl('Назад')}</Link>
			{
				props.isNewOrEditingActiveCampaign && (
					(props.isEditMode && !props.canEdit) ?
						<button className={classname({
							'button stream-submit font-proxima-nova-semibold': true,
							'disabled-btn': props.isSaveLoader
						})}>
							{intl('Клонировать поток')}
						</button> :
						<button className={classname({
							'button stream-submit font-proxima-nova-semibold': true,
							'disabled-btn': props.isSaveLoader
						})}>
							{props.isSaveLoader ? intl('Сохраняю поток') : intl('Сохранить поток')}
						</button>
				)
			}

		</div>
	);
};

PartPostback.propTypes = {
	shouldShowStatus: PropTypes.object,
	sections: PropTypes.object,
	data: PropTypes.object,
	formData: PropTypes.object,
	landingSnippets: PropTypes.array,
	isOtherAdv: PropTypes.bool,
	isSaveLoader: PropTypes.bool,
	isEditMode: PropTypes.bool,
	canEdit: PropTypes.bool,
	isNewOrEditingActiveCampaign: PropTypes.bool,
	onChecked: PropTypes.func,
	intl: PropTypes.func
};

export default PartPostback;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/stream-form/part-postback.js